// extracted by mini-css-extract-plugin
export default {"formGroup":"NOksZQnpx4UMDPT_ZCfe","row":"QpNDWafN0UAf_233Qdzr","col":"uj7PRvdVMcNhCySbeRDo","delete":"Q8GD6UNytl0nnHg17C7u","fadeIn":"uw1Otjm4lqoAhTB24kTo"};